import * as React from 'react';
type Props = {
  className?: string;
};
export function TruckWithExclamation({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-TruckWithExclamation"
      className={className}
    >
      <path
        d="M18.6666 23.9999V7.99992C18.6666 7.29267 18.3857 6.6144 17.8856 6.1143C17.3855 5.6142 16.7072 5.33325 16 5.33325H14.1666M6.66663 23.9999H3.99996C3.64634 23.9999 3.3072 23.8594 3.05715 23.6094C2.8071 23.3593 2.66663 23.0202 2.66663 22.6666V18.3333"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 24H12"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3333 24.0001H28C28.3536 24.0001 28.6927 23.8596 28.9428 23.6096C29.1928 23.3595 29.3333 23.0204 29.3333 22.6667V17.8001C29.3328 17.4975 29.2293 17.2041 29.04 16.9681L24.4 11.1681C24.2753 11.0119 24.1171 10.8858 23.937 10.799C23.757 10.7122 23.5598 10.667 23.36 10.6667H18.6666"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6667 26.6666C24.1394 26.6666 25.3333 25.4727 25.3333 23.9999C25.3333 22.5272 24.1394 21.3333 22.6667 21.3333C21.1939 21.3333 20 22.5272 20 23.9999C20 25.4727 21.1939 26.6666 22.6667 26.6666Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33329 26.6666C10.8061 26.6666 12 25.4727 12 23.9999C12 22.5272 10.8061 21.3333 9.33329 21.3333C7.86053 21.3333 6.66663 22.5272 6.66663 23.9999C6.66663 25.4727 7.86053 26.6666 9.33329 26.6666Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4866 13L9.15329 3.66665C9.037 3.46146 8.86836 3.29078 8.66457 3.17203C8.46078 3.05329 8.22915 2.99072 7.99329 2.99072C7.75743 2.99072 7.52579 3.05329 7.322 3.17203C7.11822 3.29078 6.94958 3.46146 6.83329 3.66665L1.49995 13C1.38241 13.2036 1.32077 13.4346 1.32129 13.6697C1.32181 13.9047 1.38447 14.1355 1.50292 14.3385C1.62136 14.5416 1.79138 14.7097 1.99575 14.8259C2.20011 14.942 2.43156 15.0021 2.66662 15H13.3333C13.5672 14.9997 13.797 14.938 13.9995 14.8208C14.202 14.7037 14.3701 14.5354 14.487 14.3327C14.6038 14.1301 14.6653 13.9002 14.6653 13.6663C14.6652 13.4324 14.6036 13.2026 14.4866 13Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7V9.66667"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.3333H8.00667"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
